// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Failure/style.css
// module id = 2088
// module chunks = 0